import React from 'react';
import { FadeIn } from './FadeIn';
import { AlertCircleIcon } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-20 px-6 bg-navy-900" data-id="element-135">
      <div className="max-w-4xl mx-auto" data-id="element-136">
        <FadeIn data-id="element-137">
          <div className="flex items-center justify-center mb-8" data-id="element-138">
            <AlertCircleIcon className="w-8 h-8 text-red-500 mr-3" data-id="element-139" />
            <h2 className="font-serif text-3xl md:text-4xl font-bold text-center" data-id="element-140">
              El Problema con los Consejos Tradicionales
            </h2>
          </div>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-141">
          <div className="bg-navy-800 p-8 md:p-10 rounded-2xl border border-slate-800 shadow-lg" data-id="element-142">
            <p className="text-lg text-slate-300 leading-relaxed mb-6" data-id="element-143">
              La mayoría de los consejos para la migraña son inútiles para
              alguien con una vida activa. Te dicen que{' '}
              <span className="text-red-400" data-id="element-144">"evites el estrés"</span> o que{' '}
              <span className="text-red-400" data-id="element-145">"duermas 8 horas"</span>, pero
              trabajas bajo presión y el descanso es un lujo que no siempre
              tienes.
            </p>

            <div className="space-y-4 text-slate-300" data-id="element-146">
              <div className="flex items-start" data-id="element-147">
                <div className="w-2 h-2 rounded-full bg-red-500 mt-2.5 mr-4 flex-shrink-0" data-id="element-148" />
                <p data-id="element-149">
                  Cuando el dolor ataca, los analgésicos tardan 40 minutos en
                  hacer efecto (si es que lo hacen), y para entonces, tu día ya
                  está arruinado.
                </p>
              </div>
              <div className="flex items-start" data-id="element-150">
                <div className="w-2 h-2 rounded-full bg-red-500 mt-2.5 mr-4 flex-shrink-0" data-id="element-151" />
                <p data-id="element-152">
                  Estás atrapado en un ciclo de fármacos que dañan tu estómago.
                </p>
              </div>
              <div className="flex items-start" data-id="element-153">
                <div className="w-2 h-2 rounded-full bg-red-500 mt-2.5 mr-4 flex-shrink-0" data-id="element-154" />
                <p data-id="element-155">
                  Desarrollas una sensibilidad a la luz que te hace sentir como
                  un extraño en tu propia oficina.
                </p>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}